﻿import config from "../config"
const baseUrl = config.base_url + "ns_type/"
export default {
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "post",
    },
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    get: {
        url:  baseUrl + "get",
        type: "get",
    },
    save: {
        url:  baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get"
    }

}

